import React, { Component } from "react";
import axios from "axios";
import config from "react-global-configuration";
import { Card, Label, Input, Button } from "reactstrap";
import CommonNavbar from "./commonNavbar";

class AdminIssuerBanksEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      bankDetails: {
        issuerBankDisplayName: '',
        issuerDefaultCashbackFlag: '',
        issuerMinEmiAmount: '',
        issuerTermsConditions: '',
      },
      updatedCashbackFlag: "",
      updatedMinEmiAmount: "",
      updatedTermsConditions: "",
    };
  }

  componentDidMount() {
    this.fetchBankDetails();
  }

  fetchBankDetails = () => {
    const bankId = this.props.match.params.id;
    axios
      .post(
        `${config.get("API_URL")}/brandemi/get-issuer-bank-details`,
        { id: bankId },
        { headers: { Authorization: ` ${localStorage.usertoken}` } }
      )
      .then((response) => {
        this.setState({
          bankDetails: response.data,
          updatedMinEmiAmount: response.data.issuerMinEmiAmount,
          updatedTermsConditions: response.data.issuerTermsConditions,
          updatedCashbackFlag: response.data.issuerDefaultCashbackFlag,
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching bank details:", error);
        this.setState({ loading: false });
      });
  };

  handlePreview = () => {
    const { bankDetails } = this.state;
    const bankName = bankDetails.issuerBankDisplayName;
    const termsConditions = this.state.updatedTermsConditions;

    if (!termsConditions) {
      alert("No Terms & Conditions available.");
      return;
    }

    // Make the API call to fetch JSP
    axios.post(
      `${config.get("API_URL")}/brandemi/get-chargeslip`,
      {
        issuingBank: bankName,
        termsConditions: termsConditions
      },
      {
        headers: {
          Authorization: ` ${localStorage.usertoken}`,
          "Content-Type": "application/json"
        },
        responseType: 'blob'
      }
    )
    .then((response) => {
      // Create a blob URL from the JSP response
      const file = new Blob([response.data], { type: 'text/html' });
      const fileURL = URL.createObjectURL(file);

      // Open the JSP response in a new pop-up window
      const previewWindow = window.open(fileURL, "Preview", "width=800,height=600");

      if (!previewWindow) {
        alert("Pop-up blocked! Please allow pop-ups for this site.");
      }
    })
    .catch((error) => {
      console.error("Error fetching the preview:", error);
      alert("Failed to fetch the preview.");
    });
  };


  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = () => {
    const { bankDetails, updatedMinEmiAmount, updatedCashbackFlag, updatedTermsConditions } = this.state;
    const bankId = this.props.match.params.id;

    // Validation for Cashback Flag (Only "PRE" or "POST")
    if (!["PRE", "POST"].includes(updatedCashbackFlag.toUpperCase())) {
      alert("Cashback Flag must be either 'PRE' or 'POST'.");
      return;
    }

    if (!updatedMinEmiAmount || !updatedCashbackFlag || !updatedTermsConditions) {
      alert("Please enter Min EMI Amount, Cashback Flag, and T&C.");
      return;
    }

    const confirmUpdate = window.confirm(
      `Are you sure you want to update for Bank ID : ${bankId}?`
    );
    if (!confirmUpdate) return;

    console.log("Bank Details - ", bankDetails);
    bankDetails.issuerDefaultCashbackFlag = updatedCashbackFlag;
    bankDetails.issuerMinEmiAmount = updatedMinEmiAmount;
    bankDetails.issuerTermsConditions = updatedTermsConditions;

    axios
      .post(
        `${config.get("API_URL")}/brandemi/update-issuer-bank-details`,
        {
          bankDetails: bankDetails
        },
        { headers: { Authorization: ` ${localStorage.usertoken}` } }
      )
      .then((response) => {
        alert(response.data);
        this.fetchBankDetails();
      })
      .catch((error) => {
        console.error("Error updating bank details:", error);
        alert(`Failed: ${error.response ? error.response.data : error.message}`);
      });
  };

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    const { loading, bankDetails, updatedMinEmiAmount, updatedCashbackFlag, updatedTermsConditions } = this.state;
    if (loading) return <div>Loading...</div>;

    return (
      <div className="content longcontent">
        <CommonNavbar />
        <div className="container-fluid">
          <div className="card-query-builder top-pad-5">
            <div className="col-md-12">
              <div className="card">
                <div className="header">
                  <h4 className="title pull-left">Update Issuer Bank</h4>

                  <Button
                    color="primary"
                    className="btn-capitalize pull-right"
                    onClick={this.goBack}
                  >
                    Go Back
                  </Button>

                  <Button
                    color="primary"
                    className="btn-capitalize pull-right"
                    onClick={this.handlePreview}
                    style={{ marginRight: "10px" }}
                  >
                    Preview
                  </Button>
                </div>

                <div className="content">
                  <div className="container-fluid">
                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>Issuer Bank Name</Label>
                        <Input type="text" value={bankDetails.issuerBankDisplayName} disabled />
                      </div>
                      <div className="col-md-6">
                        <Label>Cashback Flag</Label>
                        <Input
                          type="text"
                          name="updatedCashbackFlag"
                          value={updatedCashbackFlag}
                          onChange={this.handleInputChange}
                          placeholder="Enter 'PRE' or 'POST'"
                        />
                      </div>
                    </div>

                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>Min EMI Amount</Label>
                        <Input
                          type="number"
                          name="updatedMinEmiAmount"
                          value={updatedMinEmiAmount}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <Label>T&C</Label>
                        <textarea
                          className="form-control"
                          name="updatedTermsConditions"
                          value={updatedTermsConditions}
                          rows={5}
                          style={{ width: "100%", resize: "vertical" }}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="row top-margin-10">
                      <div className="col-md-12">
                        <Button color="success" onClick={this.handleSubmit}>
                          Submit Update
                        </Button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminIssuerBanksEdit;
